import React from 'react'
import styled from 'styled-components'
import { useState, useEffect } from 'react'
import { LoanAPI } from '@api'
import { useTranslation } from 'react-i18next'
import { useParams } from 'react-router-dom'
import { TitleComponent } from '../../../common/components/TitleComponent'

import { HeaderSection, FooterSection, LeafBox, Accordion } from '@components'

import './LoanDetail.scss'
const Container = styled.div`
  background-color: #ffffff;
  padding-top: 56px;
  overflow: hidden;

  @media screen and (max-width: 767px) {
    padding-top: 0;
  }
`

const Desktop = styled.div`
  display: none;
  @media (min-width: 767px) {
    display: block;
  }
`

const Mobile = styled.div`
  display: none;
  @media screen and (max-width: 767px) {
    display: block;
  }
`

const LoanDetail = function () {
  const { t } = useTranslation()

  const { id } = useParams()
  const [data, setdata] = useState({})
  const [isLoading, setisLoading] = useState(false)

  const loadData = async function () {
    setisLoading(true)
    const reportData = await LoanAPI(`/${id}`)
    setdata(reportData.data.data)
    setisLoading(false)
  }

  useEffect(() => {
    loadData()
  }, [])

  return (
    <Container>
      <TitleComponent title={data.title} />
      {!isLoading && (
        <div className="saving-detail">
          <Desktop>
            <HeaderSection
              title={data.title}
              group={t('solusi_masa_depan_anda')}
              description={data.description}
              banner={data.imageBannerDesktop}
              showButton={false}
            />
          </Desktop>
          <Mobile>
            <HeaderSection
              title={data.title}
              group={t('solusi_masa_depan_anda')}
              description={data.description}
              banner={data.imageBannerMobile}
              showButton={false}
            />
          </Mobile>

          <div className="p-0 m-0 container-fluid">
            <div className="mb-4 mb-lg-0 mx-0 px-lg-5 mx-lg-5 flex align-items-center position-relative row">
              {typeof data.dataBlockKeunggulan != 'undefined' &&
                data.dataBlockKeunggulan.length > 0 && (
                  <div>
                    <h2
                      className="mt-5 mb-4 section-title"
                      dangerouslySetInnerHTML={{
                        __html: t('solusi_tabungan_keunggulan', {
                          tabungan: data.title,
                        }),
                      }}
                    ></h2>

                    <div className="row">
                      {data.dataBlockKeunggulan.map((item, index) => {
                        return (
                          <LeafBox
                            key={index}
                            size={4}
                            number={index + 1}
                            title={item.titleManfaatTabungan}
                            description={item.descriptionManfaatTabungan}
                          />
                        )
                      })}
                    </div>
                  </div>
                )}

              {typeof data.dataBlockFitur != 'undefined' &&
                data.dataBlockFitur.length > 0 && (
                  <div>
                    <h2 className="mt-5 section-title">{t('kegunaan')}</h2>

                    <div className="row pb-5">
                      {data.dataBlockFitur.map((item, index) => {
                        return (
                          <div className="col-lg-4 col-12">
                            <div className="card mt-4">
                              <div className="card-body">
                                <h5 className="card-title">
                                  {item.titleFitur}
                                </h5>
                                <p
                                  dangerouslySetInnerHTML={{
                                    __html: item.descriptionFitur,
                                  }}
                                ></p>
                              </div>
                            </div>
                          </div>
                        )
                      })}
                    </div>
                  </div>
                )}

              {typeof data.dataBlockJenisFasilitas != 'undefined' &&
                data.dataBlockJenisFasilitas.length > 0 && (
                  <div>
                    <h2 className="mt-5 mb-4 section-title">
                      {t('jenis_jenis_fasilitas')}
                    </h2>

                    <div className="row">
                      {data.dataBlockJenisFasilitas.map((item, index) => {
                        return (
                          <div className="col-lg-4 col-12">
                            <div className="card mt-4">
                              <div className="card-body">
                                <h5 className="card-title">
                                  {item.titleJenisFasilitas}
                                </h5>
                                <p
                                  dangerouslySetInnerHTML={{
                                    __html: item.descriptionJenisFasilitas,
                                  }}
                                ></p>
                              </div>
                            </div>
                          </div>
                        )
                      })}
                    </div>
                  </div>
                )}

              {typeof data.dataBlockAccordion != 'undefined' &&
                data.dataBlockAccordion.length > 0 && (
                  <div className="mb-5">
                    <h2 className="mt-5 mb-4 section-title">
                      {t('persyaratan')}
                    </h2>

                    <div className="row">
                      {data.dataBlockAccordion.map((item, index) => {
                        return (
                          <Accordion key={index} title={item.titleAccordion}>
                            {item.contentAccordion}
                          </Accordion>
                        )
                      })}
                    </div>
                  </div>
                )}
            </div>
          </div>
        </div>
      )}

      <FooterSection currentPage={t('pinjaman')} />
    </Container>
  )
}

export default LoanDetail
